import {DataStatus} from 'platform/components';

import {head, isNil, isNotNil} from 'ramda';

import {useGetRentalOrderQuery} from '@dms/api/rental';
import i18n from '@dms/i18n';

import {useRequiredParams} from 'shared/web';

import {InspectionDetail} from './components/InspectionDetail';

export function ReturnInspections() {
  const {id: rentalOrderId} = useRequiredParams();
  const {data: rentalOrder, isLoading: isLoadingRentalOrder} = useGetRentalOrderQuery({
    rentalOrderId,
  });

  const returnInspectionId = head(rentalOrder?.returnVehicleInspections ?? []);
  const vehicleId = rentalOrder?.rentalVehicleId;

  return (
    <DataStatus
      isLoading={isLoadingRentalOrder}
      isEmpty={isNil(returnInspectionId)}
      emptyMessage={i18n.t('page.rentalOrder.labels.noReturnInspection')}
      minHeight={75}
    >
      {isNotNil(returnInspectionId) && isNotNil(vehicleId) && (
        <InspectionDetail isRent={false} vehicleId={vehicleId} inspectionId={returnInspectionId} />
      )}
    </DataStatus>
  );
}
